import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

export const updateAttributeFunc = createAsyncThunk("update attribute function", async ({ id, data }, thunkAPI) => {
  try {
    const response = await api.put(`/dashboard/attributes/${id}`, data);
    return response.data.data.attribute;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);

  }
});

const updateAttributeSlicer = createSlice({
  name: "update attribute slicer",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateAttributeFunc.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.apiErrors = {};
    })
      .addCase(updateAttributeFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";

      })
      .addCase(updateAttributeFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default updateAttributeSlicer.reducer;
